var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5302734,9.8364258c-0.2929688-0.2929688-0.7675781-0.2929688-1.0605469,0l-0.9959106,0.9959106 c-0.572998-4.2210693-4.1914673-7.4880981-8.5675659-7.4880981c-4.7729492,0-8.65625,3.8828125-8.65625,8.6552734 c0,4.7734375,3.8833008,8.65625,8.65625,8.65625c1.6293945,0,3.2167969-0.4550781,4.5913086-1.3164062 c0.3510742-0.2207031,0.4570312-0.6826172,0.2373047-1.0341797c-0.2207031-0.3505859-0.6826172-0.4560547-1.0341797-0.2373047 c-1.1352539,0.7119141-2.4472656,1.0878906-3.7944336,1.0878906c-3.9458008,0-7.15625-3.2099609-7.15625-7.15625 c0-3.9453125,3.2104492-7.1552734,7.15625-7.1552734c3.6589355,0,6.6802979,2.7616577,7.1010132,6.3088989L17.690918,9.8364258 c-0.2929688-0.2929688-0.7675781-0.2929688-1.0605469,0s-0.2929688,0.7675781,0,1.0605469l2.4194336,2.4199219 c0.140625,0.140625,0.331543,0.2197266,0.5302734,0.2197266s0.3896484-0.0791016,0.5302734-0.2197266l2.4199219-2.4199219 C22.8232422,10.6040039,22.8232422,10.1293945,22.5302734,9.8364258z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/Rotate.4393e488b36eb92059d24b71a6fe9df0.svg";
export { ForwardRef as ReactComponent };